import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Building2, Users, Anchor, Share2, Download } from 'lucide-react';
import { AnimatedSection } from '../components/AnimatedSection';
export function HomePage() {
  return <div data-id="element-404">
      {/* Hero Section — Centered Text */}
      <section className="py-28 md:py-36 lg:py-44 px-4 sm:px-6 lg:px-8" data-id="element-405">
        <div className="max-w-4xl mx-auto text-center" data-id="element-406">
          <AnimatedSection data-id="element-407">
            <p className="text-lg text-brand-brown mb-6 leading-relaxed" data-id="element-408">
              Finding impactful organisations is hard. Knowing the ones with
              solid leadership, processes and governance, is harder still.
            </p>
          </AnimatedSection>
          <AnimatedSection delayClass="delay-200" data-id="element-409">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif text-brand-charcoal leading-tight mb-6" data-id="element-410">
              Firetree offers funders curated access to established,
              high-capacity local organizations with proven models in Southeast
              Asia.
            </h1>
          </AnimatedSection>
          <AnimatedSection delayClass="delay-300" data-id="element-411">
            <p className="text-base text-brand-brown mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-412">
              Each organisation in this portfolio has been selected by members
              of the Firetree team who have created, run and backed
              organisations themselves.
            </p>
          </AnimatedSection>
          <AnimatedSection delayClass="delay-400" data-id="element-413">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-414">
              <Link to="/how-we-work" className="inline-flex items-center justify-center px-8 py-3.5 bg-brand-red text-white font-semibold rounded-full hover:bg-brand-charcoal transition-all duration-300 shadow-sm hover:shadow-md group" data-id="element-415">
                Who we are
                <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform" data-id="element-416" />
              </Link>
              <a href="#" className="inline-flex items-center justify-center px-8 py-3.5 border border-brand-red text-brand-red font-semibold rounded-full hover:bg-brand-red hover:text-white transition-all duration-300 group" data-id="element-417">
                <Download className="mr-2 w-4 h-4" data-id="element-418" />
                Download prospectus
              </a>
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* Image Breaker 1 - Rice Terraces */}
      <AnimatedSection data-id="element-419">
        <div className="relative h-64 md:h-96 w-full overflow-hidden" data-id="element-420">
          <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transform hover:scale-105 transition-transform duration-1000" style={{
          backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/3xLkYvXr5XqeBT956oRjkv/Teach_for_the_Philippines_-_Website_Banner_-_Fellowship_Program_(VVES).jpg")'
        }} data-id="element-421" />
          <div className="absolute inset-0 bg-brand-charcoal/20 mix-blend-multiply" data-id="element-422" />
          <div className="absolute inset-0 bg-texture-overlay mix-blend-overlay" data-id="element-423" />
        </div>
      </AnimatedSection>

      {/* How We Work Summary */}
      <section className="bg-brand-card/30 py-24" data-id="element-424">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-425">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-end mb-16" data-id="element-426">
            <AnimatedSection data-id="element-427">
              <div data-id="element-428">
                <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-429">
                  Our expertise
                </h2>
                <p className="text-xl text-brand-brown" data-id="element-430">
                  We have built our expertise over 20 years of working with
                  organisations, within organisations to understand the regions,
                  issues and communities that we work in.
                </p>
              </div>
            </AnimatedSection>
            <AnimatedSection delayClass="delay-200" data-id="element-431">
              <div className="flex flex-col sm:flex-row lg:flex-col xl:flex-row gap-4 lg:items-end lg:justify-end" data-id="element-432">
                <Link to="/how-we-work" className="inline-flex items-center px-6 py-3 border border-brand-red text-brand-red font-semibold rounded-full hover:bg-brand-red hover:text-white transition-all duration-300 group" data-id="element-433">
                  Our Approach
                  <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform" data-id="element-434" />
                </Link>
              </div>
            </AnimatedSection>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-435">
            <AnimatedSection delayClass="delay-100" data-id="element-436">
              <div className="bg-brand-cream p-10 border-grid border-brand-shape/50 h-full transition-colors hover:border-brand-charcoal/30 flex flex-col group" data-id="element-437">
                <div className="w-12 h-12 rounded-full bg-brand-card/60 flex items-center justify-center mb-6 icon-hover" data-id="element-438">
                  <Building2 className="w-6 h-6 text-brand-red" strokeWidth={1} data-id="element-439" />
                </div>
                <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-440">
                  We operate, not just fund
                </h3>
                <p className="text-brand-brown leading-relaxed flex-grow" data-id="element-441">
                  We fully fund and operate TCI in Manila and Starfish Education
                  Foundation in Thailand.
                </p>
              </div>
            </AnimatedSection>

            <AnimatedSection delayClass="delay-200" data-id="element-442">
              <div className="bg-brand-cream p-10 border-grid border-brand-shape/50 h-full transition-colors hover:border-brand-charcoal/30 flex flex-col group" data-id="element-443">
                <div className="w-12 h-12 rounded-full bg-brand-card/60 flex items-center justify-center mb-6 icon-hover" data-id="element-444">
                  <Users className="w-6 h-6 text-brand-red" strokeWidth={1} data-id="element-445" />
                </div>
                <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-446">
                  We've been in the room
                </h3>
                <p className="text-brand-brown leading-relaxed flex-grow" data-id="element-447">
                  We have lived through the day-to-day challenges of the
                  leadership. With Board experience across 20+ organisations, we
                  know what good governance and decision making under pressure
                  looks like.
                </p>
              </div>
            </AnimatedSection>

            <AnimatedSection delayClass="delay-300" data-id="element-448">
              <div className="bg-brand-cream p-10 border-grid border-brand-shape/50 h-full transition-colors hover:border-brand-charcoal/30 flex flex-col group" data-id="element-449">
                <div className="w-12 h-12 rounded-full bg-brand-card/60 flex items-center justify-center mb-6 icon-hover" data-id="element-450">
                  <Anchor className="w-6 h-6 text-brand-red" strokeWidth={1} data-id="element-451" />
                </div>
                <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-452">
                  We stay
                </h3>
                <p className="text-brand-brown leading-relaxed flex-grow" data-id="element-453">
                  We know that multi-year, unrestricted funding partnerships,
                  give leaders the time and space to focus on the impact of the
                  organisation.
                </p>
              </div>
            </AnimatedSection>

            <AnimatedSection delayClass="delay-400" data-id="element-454">
              <div className="bg-brand-cream p-10 border-grid border-brand-shape/50 h-full transition-colors hover:border-brand-charcoal/30 flex flex-col group" data-id="element-455">
                <div className="w-12 h-12 rounded-full bg-brand-card/60 flex items-center justify-center mb-6 icon-hover" data-id="element-456">
                  <Share2 className="w-6 h-6 text-brand-red" strokeWidth={1} data-id="element-457" />
                </div>
                <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-458">
                  We share who we back
                </h3>
                <p className="text-brand-brown leading-relaxed flex-grow" data-id="element-459">
                  Every organisation in this portfolio is one we currently fund
                  ourselves and intend to continue funding. This is not a way to
                  wind down but rather to double down.
                </p>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>

      {/* Image Breaker 2 - Floating Market / Community */}
      <AnimatedSection data-id="element-460">
        <div className="relative h-64 md:h-96 w-full overflow-hidden" data-id="element-461">
          <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transform hover:scale-105 transition-transform duration-1000" style={{
          backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/gBKwsrev8cea4N8u1LzzdP/Teach_for_the_Philippines_-_Annual_Report_SY2024_Cover_Photo_-_Fellowship_Program_(TES).jpg")'
        }} data-id="element-462" />
          <div className="absolute inset-0 bg-brand-charcoal/30 mix-blend-multiply" data-id="element-463" />
          <div className="absolute inset-0 bg-texture-overlay mix-blend-overlay" data-id="element-464" />
        </div>
      </AnimatedSection>

      {/* Who We Work With */}
      <section className="py-16 overflow-hidden" data-id="element-465">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12" data-id="element-466">
          <AnimatedSection data-id="element-467">
            <div className="max-w-3xl" data-id="element-468">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-469">
                Who we work with
              </h2>
              <p className="text-lg text-brand-brown mb-8 leading-relaxed" data-id="element-470">
                We partner with established, high-capacity organisations across
                Southeast Asia. Each has been selected through years of direct
                engagement and operational partnership.
              </p>
              <Link to="/who-we-fund" className="inline-flex items-center px-6 py-3 border border-brand-red text-brand-red font-semibold rounded-full hover:bg-brand-red hover:text-white transition-all duration-300 group" data-id="element-471">
                Discover our portfolio
                <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform" data-id="element-472" />
              </Link>
            </div>
          </AnimatedSection>
        </div>

        {/* Logo Grid */}
        <AnimatedSection delayClass="delay-200" data-id="element-473">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-474">
            <div className="flex flex-wrap lg:flex-nowrap justify-between items-center gap-8 md:gap-10" data-id="element-475">
              <img src="https://cdn.magicpatterns.com/uploads/hBKFw5Z4VmXDFzi7HBerWe/Clip_path_group-1.png" alt="Teach for the Philippines" className="h-10 md:h-12 object-contain grayscale hover:grayscale-0 transition-all duration-500 opacity-70 hover:opacity-100" data-id="element-476" />
              <img src="https://cdn.magicpatterns.com/uploads/hP2oiiQ8REiitUNvNgeWMu/Clip_path_group-2.png" alt="Stairway Foundation" className="h-10 md:h-12 object-contain grayscale hover:grayscale-0 transition-all duration-500 opacity-70 hover:opacity-100" data-id="element-477" />
              <img src="https://cdn.magicpatterns.com/uploads/kccRsmJbEXxPheXu7TEfAC/Clip_path_group-3.png" alt="Yayasan Chow Kit" className="h-10 md:h-12 object-contain grayscale hover:grayscale-0 transition-all duration-500 opacity-70 hover:opacity-100" data-id="element-478" />
              <img src="https://cdn.magicpatterns.com/uploads/rSC9sP2QtiFx63Qs8g7qAp/Clip_path_group-4.png" alt="Friends International" className="h-10 md:h-12 object-contain grayscale hover:grayscale-0 transition-all duration-500 opacity-70 hover:opacity-100" data-id="element-479" />
              <img src="https://cdn.magicpatterns.com/uploads/nuaodW4ZMkGrvMHkQXTPx7/Clip_path_group-5.png" alt="Baan Dek Foundation" className="h-10 md:h-12 object-contain grayscale hover:grayscale-0 transition-all duration-500 opacity-70 hover:opacity-100" data-id="element-480" />
            </div>
          </div>
        </AnimatedSection>
      </section>

      {/* Directory CTA Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8" data-id="element-481">
        <div className="max-w-7xl mx-auto" data-id="element-482">
          <AnimatedSection data-id="element-483">
            <div className="bg-brand-card/30 border border-brand-shape/50 rounded-2xl p-10 md:p-16 text-center shadow-sm" data-id="element-484">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-485">
                Explore our directory
              </h2>
              <p className="text-lg text-brand-brown mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-486">
                Discover the established, high-capacity local organisations we
                partner with across Southeast Asia.
              </p>
              <Link to="/who-we-fund" className="inline-flex items-center justify-center px-8 py-3.5 bg-brand-red text-white font-semibold rounded-full hover:bg-brand-charcoal transition-all duration-300 shadow-sm hover:shadow-md group" data-id="element-487">
                Discover our portfolio
                <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform" data-id="element-488" />
              </Link>
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* Image Breaker 3 - Temple / Landscape */}
      <AnimatedSection data-id="element-489">
        <div className="relative h-64 md:h-96 w-full overflow-hidden" data-id="element-490">
          <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transform hover:scale-105 transition-transform duration-1000" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1528181304800-259b08848526?q=80&w=2070&auto=format&fit=crop")'
        }} data-id="element-491" />
          <div className="absolute inset-0 bg-brand-charcoal/20 mix-blend-multiply" data-id="element-492" />
          <div className="absolute inset-0 bg-texture-overlay mix-blend-overlay" data-id="element-493" />
        </div>
      </AnimatedSection>

      {/* Who Runs the Fund */}
      <section className="text-white py-24" style={{
      backgroundColor: '#243462'
    }} data-id="element-494">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-495">
          <AnimatedSection data-id="element-496">
            <h2 className="text-3xl md:text-4xl font-serif text-white mb-8" data-id="element-497">
              Who runs the Fund
            </h2>
          </AnimatedSection>
          <AnimatedSection delayClass="delay-200" data-id="element-498">
            <p className="text-lg md:text-xl text-white/80 mb-10 leading-relaxed" data-id="element-499">
              The Firetree Fund is managed by Sreya Bhattacharya, governed by
              the Firetree Board chaired by Francesco Caruso, and advised by a
              regional panel of technical experts chaired by Nicky Wilkinson.
              The panel brings decades of direct experience across child
              protection, education and nonprofit leadership in Southeast Asia.
            </p>
          </AnimatedSection>
          <AnimatedSection delayClass="delay-400" data-id="element-500">
            <a href="https://firetree.org/team" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-6 py-3 border rounded-full font-semibold transition-all duration-300 group" style={{
            color: '#aacafe',
            borderColor: '#aacafe'
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = '#aacafe';
            e.currentTarget.style.color = '#243462';
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = '#aacafe';
          }} data-id="element-501">
              Meet the entire Firetree team at firetree.org/team
              <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform -rotate-45" data-id="element-502" />
            </a>
          </AnimatedSection>
        </div>
      </section>
    </div>;
}